import React from "react";
import { useAuth } from "../lib/auth";
import { Navigate, useLocation } from "react-router-dom";
import { SplashScreen } from "./Brand";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return <SplashScreen message="Loading your provenance workspace…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
